// '카트 페이지에서' 카트 드로어에 업데이트 사항이 생겼을 시, 업데이트 된 사항들이 카트페이지에도 새로고침 없이 즉시 반영
// Only in cart page, when make changes to cart items in cart drawer, the updated items are immediately reflected in the cart page without refreshing
document.addEventListener('DOMContentLoaded', async () => {
  // 이전 카트 상태 저장 : 업데이트 사항 없으면 업데이트 관련 코드 실행하지 않음
  // Store the previous cart state: If there is no update, skip the update related code (For optimization)
  let previousCartState = null;

  const isCartStateChanged = (currentCartData) => {
    if (!previousCartState) return true;

    if (previousCartState.item_count !== currentCartData.item_count) return true;

    if (previousCartState.items.length !== currentCartData.items.length) return true;

    for (let i = 0; i < currentCartData.items.length; i++) {
      const currentItem = currentCartData.items[i];
      const previousItem = previousCartState.items.find(item => item.variant_id === currentItem.variant_id);

      if (!previousItem) return true;
      if (previousItem.quantity !== currentItem.quantity) return true;
      if (previousItem.final_price !== currentItem.final_price) return true;
    }

    if (previousCartState.items_subtotal_price !== currentCartData.items_subtotal_price) return true;

    return false;
  }

  const shopifyStorefrontAccessToken = '7d498ec600e6cf79454ef2c37e52f070';
  const cartDrawerCloseButton = document.querySelector('[data-cart-drawer-close-button]');
  const cartDrawerOverlay = document.querySelector('[data-cart-drawer-overlay]');

  const formatPrice = cents => {
    const yen = cents / 100;
    return yen.toLocaleString('ja-JP', {
      style: 'currency',
      currency: 'JPY',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  };

  const fetchShippingRates = async () => {
    try {
      const res = await fetch(
        '/cart/shipping_rates.json?shipping_address%5Bzip%5D=1000001&shipping_address%5Bcountry%5D=JP&shipping_address%5Bprovince%5D=Tokyo',
        { credentials: 'same-origin' }
      );
      const json = await res.json();
      if (json.shipping_rates?.length) {
        return toCents(json.shipping_rates[0].price, 'JPY');
      }
      return 0;
    } catch (err) {
      console.error('Error fetching shipping rates:', err);
      return 0;
    }
  }

  [cartDrawerCloseButton, cartDrawerOverlay].forEach(async (element) => {
    element.addEventListener('click', async () => {
      element.closest('cart-drawer').close();

      const updatedCart = await fetch('/cart.js');
      const updatedCartData = await updatedCart.json();

      if (!isCartStateChanged(updatedCartData)) {
        console.log("Cart state has not changed, skipping update");
        return;
      }

      previousCartState = updatedCartData;

      // 상품 총 수량 업데이트 (카트페이지 타이틀 영역 & 헤더 영역)
      // Update the total number of products (cart page title area & header area)
      const cartTotalQuantityElement = document.querySelector('[data-title-cart-item-count]');
      const cartTotalQuantityHeaderElement = document.querySelector('[data-cart-count-number]');
      const cartBubbleCountElement = document.querySelector('[data-cart-bubble-count]');

      if (cartTotalQuantityElement && cartTotalQuantityHeaderElement) {
        cartTotalQuantityElement.textContent = `(${updatedCartData.item_count})`;
        cartTotalQuantityHeaderElement.textContent = `${updatedCartData.item_count}`;
      }

      if (cartBubbleCountElement) {
        cartBubbleCountElement.textContent = `${updatedCartData.item_count}`;
      }

      // 각 상품 업데이트
      // Update each product
      const cartItemsTable = document.querySelector('[data-cart-items-table]');

      const cartItemsHTML = [];

      for (const newItem of updatedCartData.items) {
        const thumbnailQuery = `{
          product(handle: "${newItem.handle}") {
            metafields(identifiers: [
              { namespace: "custom", key: "product_plp_thumbnail" }
            ]) {
              key
              value
              reference {
                ... on MediaImage {
                  image {
                    url
                  }
                }
              }
            }
          }
        }`

        const thumbnailRes = await fetch('/api/2024-01/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': shopifyStorefrontAccessToken,
          },
          body: JSON.stringify({ query: thumbnailQuery })
        })

        const thumbnailData = await thumbnailRes.json();
        const thumbnailUrl = thumbnailData.data.product.metafields[0].reference.image.url;

        const newCartItemHTML = `
          <tr class="cart-item" id="CartItem-${updatedCartData.items.indexOf(newItem) + 1}">
            <td class="cart-item__media">
              <a href="${newItem.url}" class="cart-item__link" aria-hidden="true" tabindex="-1"> </a>
              <div class="cart-item__image-container gradient global-media-settings">
                <img
                  src="${thumbnailUrl}"
                  class="cart-item__image"
                  alt="${newItem.image.alt || ''}"
                  loading="lazy"
                  width="200"
                  height="200"
                >
              </div>
            </td>
            <td class="minitmute-cart-item__details cart-item__details">
              <a href="${newItem.url}" class="cart-item__name h4 break">${newItem.product_title}</a>
              <div class="cart-item__product-colors">
                <p>${newItem.product_type}</p>
              </div>
              <div class="product-option">
                ${formatPrice(newItem.final_price)}
              </div>
              ${!newItem.product_has_only_default_variant ? 
                `${newItem.options_with_values.map((value) => {
                  return `
                    <div class="product-option" style="margin-top: 25px;">
                      <dt>${value.name}:</dt>
                      <dd>${value.value}</dd>
                    </div>
                  `;
                }).join('')}` : ''
              }
              ${newItem.properties ? `${Object.entries(newItem.properties).map(([key, value]) => `
                <div class="cart-item__product-shipping-info" style="margin-top: ${
                  !newItem.product_has_only_default_variant ? '5px' : '34px'};">
                  <p>${key}:<br>${value}</p>
                </div>`
                ).join('')}`
              : ''}
            </td>
            <td class="cart-item__quantity">
              <quantity-popover class="quantity-popover">
                <div class="cart-item__quantity-wrapper quantity-popover-wrapper">
                  <cart-remove-button
                    id="Remove-${updatedCartData.items.indexOf(newItem) + 1}"
                    class="cart-remove-button"
                    data-index="${updatedCartData.items.indexOf(newItem) + 1}"
                    data-cart-remove-button
                  >
                    <a
                      href="${newItem.url_to_remove}"
                      class="button button--tertiary"
                      aria-label="商品を削除"
                    >
                      <span class="svg-wrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17">
                          <path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"/>
                        </svg>
                      </span>
                    </a>
                  </cart-remove-button>
                  <quantity-input class="quantity cart-quantity minitmute-quantity">
                    <button
                      class="quantity__button"
                      name="minus"
                      type="button"
                      disabled
                      data-cart-quantity-button
                    >
                      <span class="visually-hidden">Decrease quantity</span>
                      <span class="svg-wrapper" style="color: #a2a2a2;">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-minus" viewBox="0 0 10 2">
                          <path fill="currentColor" fill-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1" clip-rule="evenodd"/>
                        </svg>
                      </span>
                    </button>
                    <input
                      class="quantity__input"
                      data-quantity-variant-id="${newItem.variant_id}"
                      type="number"
                      name="updates[]"
                      value="${newItem.quantity}"
                      data-cart-quantity="${newItem.quantity}"
                      min="0"
                      data-min="1"
                      step="1"
                      aria-label="Quantity"
                      id="Quantity-${updatedCartData.items.indexOf(newItem) + 1}"
                      data-index="${updatedCartData.items.indexOf(newItem) + 1}"
                    >
                    <button class="quantity__button" name="plus" type="button" data-cart-quantity-button>
                      <span class="visually-hidden">Increase quantity</span>
                      <span class="svg-wrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10">
                          <path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"/>
                        </svg>
                      </span>
                    </button>
                  </quantity-input>
                </div>
              </quantity-popover>
            </td>
          </tr>
        `;
        cartItemsHTML.push(newCartItemHTML);
      }

      cartItemsTable.innerHTML = '';
      cartItemsTable.innerHTML = cartItemsHTML.join('');


      // 상품 총 가격 업데이트
      // Update the total price of products
      const cartItemMerchandisePriceElement = document.querySelector('[data-cart-merchandise-price]');
      
      if (cartItemMerchandisePriceElement) {
        cartItemMerchandisePriceElement.textContent = formatPrice(updatedCartData.items_subtotal_price);
      }

      // 배송비 책정 유무에 따른 배송비 업데이트
      // Update the shipping fee depending on whether shipping is set
      const shippingPriceElement = document.querySelector('[data-cart-shipping-price]');
      if (shippingPriceElement) {
        shippingPriceElement.textContent = formatPrice(await fetchShippingRates());
      }

      // 최종 토탈 가격 업데이트
      // Update the final total price
      const cartTotalPriceElement = document.querySelector('[data-cart-total-price]');
      if (cartTotalPriceElement) {
        cartTotalPriceElement.textContent = formatPrice(updatedCartData.items_subtotal_price + await fetchShippingRates());
      }
    })
  })
});